/** @format */

import React from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import LogoWhite from "../assets/images/logowhite.png";
import Resume from "../assets/resume.pdf";

function gotoTop () {
	gotoTop;
}

class NavBar extends React.Component {
	render() {
		return (
			<>
				
				<nav>
					<div className="image-link">
						<NavLink exact to="/" activeClassName="noclass" onClick={gotoTop}>
							<img src={Logo} className="logo dark" alt="" />
							<img
								src={LogoWhite}
								className="logo white"
								alt=""
							/>
						</NavLink>
					</div>

					<ul className="sidebar">
						<i className="fas fa-times close"></i>
						<li>
							<NavLink activeClassName="active" exact to="/">
								HOME
							</NavLink>
						</li>
						<li>
							<NavLink activeClassName="active" to="/hire" onClick={gotoTop}>
								HIRE
							</NavLink>
						</li>
						
						<li>
							<NavLink activeClassName="active" to="/blog">
								WRITING
							</NavLink>
						</li>
						<li className="downloads">
							<a
								href={Resume}
								className="btn btn-success download btn-block"
								download="resume"
							>
								DOWNLOAD CV
							</a>
						</li>
					</ul>
					<i className="fas fa-stream open"></i>
				</nav>
			</>
		);
	}
}

export default NavBar;